import React from "react";
import "./css/AboutUs.css";
import headerBg from "./assets/picOne.png"; // reuse or replace with a relevant image

const CQPProgram = () => {
  return (
    <div className="about-us">
      {/* === Header Section === */}
      <section className="about-header">
        <div className="overlay">
          <h1 className="page-title">Certified Quality Professional (CQP) Program</h1>
          <p className="subtitle">
            The Malawi Bureau of Standards (MBS) offers the Certified Quality Professional (CQP) program to recognize and develop skilled professionals in quality management.
          </p>
          <p className="subtitle">
            The CQP program equips individuals with advanced knowledge, practical skills, and competencies needed to drive quality, compliance, and best practices across industries.
          </p>
        </div>
      </section>

      {/* === Program Overview Section === */}
      <section className="intro-section">
        <h2 className="section-title">Program Overview</h2>
        <div className="row">
          <div className="col-md-6">
            <ul>
              <li>Comprehensive training on quality management systems (ISO 9001, ISO 14001, ISO 45001, etc.)</li>
              <li>Understanding regulatory compliance and standards implementation</li>
              <li>Practical techniques for quality improvement and process optimization</li>
              <li>Risk management, auditing, and performance monitoring</li>
              <li>Ethics, professionalism, and leadership in quality management</li>
            </ul>
          </div>
          <div className="col-md-6">
            <ul>
              <li>Hands-on workshops and case studies for real-world application</li>
              <li>Assessment and certification of professional competence</li>
              <li>Continuous professional development opportunities</li>
              <li>Networking with industry peers and quality experts</li>
              <li>Access to MBS resources, publications, and technical guidance</li>
            </ul>
          </div>
        </div>
      </section>

      {/* === Certification Process Section === */}
      <section className="functions-section">
        <h2 className="section-title">Certification Process</h2>
        <p>
          Individuals undergo structured training, assessments, and evaluations to demonstrate competence in quality management. 
          Successful candidates are awarded the Certified Quality Professional (CQP) designation, recognized nationally and internationally.
        </p>
      </section>

      {/* === Contact Section === */}
      <section className="functions-section">
        <h2 className="section-title">Contact for CQP Program</h2>
        <p>
          For inquiries, registration, or additional information on the CQP program, please contact the MBS Training and Certification Department.
        </p>
        <div className="row">
          <div className="col-md-6">
            <ul>
              <li>Email: <a href="mailto:training@mbs.mw">training@mbs.mw</a></li>
              <li>Phone: +265 (0) 1 789 666</li>
            </ul>
          </div>
          <div className="col-md-6">
            <ul>
              <li>Office: Malawi Bureau of Standards, P.O. Box 946, Blantyre, Malawi</li>
              <li>Website: <a href="https://www.mbs.mw">www.mbs.mw</a></li>
            </ul>
          </div>
        </div>
        <p className="subtitle">
          The CQP program enhances professional competence, promotes quality culture, and empowers individuals to contribute to industry excellence in Malawi.
        </p>
      </section>

      <br /><br />
    </div>
  );
};

export default CQPProgram;
